import 'slick-carousel';
import 'selectric';

export default {
	init() {
		$(function() {
			$('.news__slider').slick({
        infinite: true,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        pauseOnFocus: false,
      });


		});

		jQuery( document ).ready( function($) {
			$(document).on( 'nfFormReady', function() {
				$('select').selectric();
			});

      /*eslint-disable*/
      if(!sage_vars.is_home){
        var timer = setTimeout(function(){
          window.location.replace('/')
        }, 90000);

        function resetTimer(){
          console.log('resetTimer')
          clearTimeout(timer);
          timer = setTimeout(function(){
            window.location.replace('/')
          }, 90000);
        }

        $(document).on('click change mousemove keyup keypress', function(){
          resetTimer();
        });
      }
      /*eslint-enable */

    } );


  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js